import { API_URL } from "../../utils/constants/api.constants";
import { LocalStorage } from "../LocalStorage/LocalStorage";
import axios from "axios";
import ROLES from "../../utils/constants/roles.constants";
import moment from "moment";

class Auth {
  async login(username, password) {
    var data = JSON.stringify({
      username: username,
      password: password,
    });

    if (username === "dev") {
      LocalStorage.set(
        "user",
        JSON.stringify({
          role: ROLES.DEVELOPER,
          name: "dev",
          expires_in: 1000000,
          expires_at: moment().add(1, "day").toString(),
        })
      );
      return 200;
    }

    var config = {
      method: "post",
      url: `${API_URL}/login/`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(config)
      .then((response) => {
        var response_data = response.data;
        var user = {
          id: response_data["id"] === "" ? "1" : response_data["id"],
          name:
            response_data["full_name"] === ""
              ? "No Name"
              : response_data["full_name"],
          role:
            response_data["role_pengguna"] === ""
              ? ROLES.ADMIN
              : response_data["role_pengguna"],
          token: response_data["token"],
          expires_in: response_data["expires_in"],
          expires_at: moment()
            .add(response_data["expires_in"] - 300, "seconds")
            .toString(),
        };
        LocalStorage.set("user", JSON.stringify(user));
        return response.status;
      })
      .catch((error) => {
        return error.response.status;
      });
  }

  logout() {
    LocalStorage.remove("user");
    LocalStorage.clear();
  }

  register() {}

  getCurrentUser() {
    const user = LocalStorage.get("user");
    return user != null ? JSON.parse(user) : null;
  }

  tokenIsExpired() {
    let user = LocalStorage.get("user");
    if (!user) return false;
    user = JSON.parse(user);
    let now = moment();
    let expires_at = moment(user.expires_at);
    if (now.isAfter(expires_at)) {
      return true;
    }
    return false;
  }

  refreshTokenExpiration() {
    let user = LocalStorage.get("user");
    if (!user) return;
    user = JSON.parse(user);
    user.expires_at = moment()
      .add(user.expires_in - 300, "seconds")
      .toString();
    LocalStorage.set("user", JSON.stringify(user));
  }
}

export default new Auth();
